import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { DeviationResourceType } from '../../../types/deviation';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import s from './SubscribeToUnlockTooltip.scss';
var TOOLTIP_WIDTH = 144;
var SubscribeToUnlockTooltip = function (_a) {
    var deviation = _a.deviation, children = _a.children, forceVisible = _a.forceVisible, className = _a.className;
    var t = useTranslation().t;
    var _b = useSubscriptionTier(deviation), tier = _b.tier, isTier = _b.isTier, isOwner = _b.isOwner, isUserSubscribed = _b.isUserSubscribed, subscriptionsTabUrl = _b.subscriptionsTabUrl, needsSubscription = _b.needsSubscription, isSubscribedButBlocked = _b.isSubscribedButBlocked;
    var isSubscribedTier = isTier && !isOwner && isUserSubscribed;
    var isInASubscribedTier = !isTier && !needsSubscription && !isSubscribedButBlocked;
    if (isSubscribedTier || isInASubscribedTier || !(tier === null || tier === void 0 ? void 0 : tier.author)) {
        return React.createElement(React.Fragment, null, children);
    }
    var description = isSubscribedButBlocked
        ? t('deviation.tier.subscribersOnly.tooltip.lockedSubscribed')
        : t('deviation.tier.subscribersOnly.tooltip.unsubbed');
    return (React.createElement(SophisticatedTooltip, { className: className, size: "large", width: TOOLTIP_WIDTH, placement: "top", "aria-label": description, description: description, isVisible: forceVisible ? true : undefined, postfix: React.createElement(SophisticatedTooltipLink, { href: subscriptionsTabUrl, className: s['subs-link'], biData: {
                evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
                referral_info: ReferralType.ACTION_BAR,
                typeid: DeviationResourceType.TIER,
                itemid: tier === null || tier === void 0 ? void 0 : tier.deviationId,
            } }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink')) }, children));
};
SubscribeToUnlockTooltip.displayName = 'SubscribeToUnlockTooltip';
export default SubscribeToUnlockTooltip;
//# sourceMappingURL=SubscribeToUnlockTooltip.js.map